module.exports = __webpack_public_path__ + "static/authentication-flow-f993e459b1919126e48e251727f7df13.svg";